module.exports = __webpack_public_path__ + "static/media/end_of_utterance.21dd7c11.mp3";